import type { Instrument } from '@thinkalpha/common/schemas/instruments.js';

export type UpdateExecutionsInstrumentAction = {
    type: 'updateExecutionsInstrument' | 'linkingUpdateExecutionsInstrument';
    tabId: string;
    instrument: Instrument;
};
export const updateExecutionsInstrument = (
    tabId: string,
    instrument: Instrument,
    linking = false,
): UpdateExecutionsInstrumentAction => ({
    tabId,
    instrument,
    type: linking ? 'linkingUpdateExecutionsInstrument' : 'updateExecutionsInstrument',
});

export type UpdateExecutionsAccountAction = {
    type: 'updateExecutionsAccount';
    tabId: string;
    accountId: string | null;
};
export const updateExecutionsAccount = (tabId: string, accountId: string): UpdateExecutionsAccountAction => ({
    tabId,
    accountId,
    type: 'updateExecutionsAccount',
});

export type ExecutionsActions = UpdateExecutionsInstrumentAction | UpdateExecutionsAccountAction;
